import React, { useState, useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import get from 'lodash/get';
import { useResizeX } from 'Hooks/useResize';
import useWindowDimensions from 'Hooks/useWindowSize';
import useShortcutScope from 'Hooks/useShortcutScope';
import useFormShortcuts from 'Hooks/useFormShortcuts';
import Header from './components/Header';
import {
  Wrapper, ResizerWrapper, DetailWrapper, Resizer,
  Transparency
} from './styled';
import { selectVulnTemplateDetail } from 'store/KnowledgeBase/selectors';
import { redirectToVulnTemplate } from 'Screens/Contextualization/KnowledgeBase/actions/Actions';
import Tabs from './components/Tabs';
import TabsSelector from './components/Tabs/components/TabSelector';

const VulnTemplateDetail = () => {
  const dispatch = useDispatch();
  const data = useSelector(selectVulnTemplateDetail);
  const [showTransparency, setShowTransparency] = useState(false);
  const ref = useRef(null);
  const wrapperRef = useRef(null);
  const resizerRef = useRef(null);
  const { width } = useWindowDimensions();
  const minWidth = width < 3000 ? width * 0.55 : width * 0.35;
  const maxWidth = width < 3000 ? width * 0.75 : width * 0.55;
  const wrapperWidth = useResizeX(wrapperRef, resizerRef, minWidth, minWidth, maxWidth);
  const shortcutScope = useShortcutScope('vuln-detail');

  const handleClose = () => dispatch(redirectToVulnTemplate());

  useFormShortcuts({ onCancel: handleClose, scope: shortcutScope, cancelLabel: 'Close' });

  const onScroll = () => {
    const scrollTop = get(ref, 'current.scrollTop', 0);
    if (scrollTop === 0) setShowTransparency(false);
    else setShowTransparency(true);
  };

  return data
    ? (
    <Wrapper ref={ wrapperRef } wrapperWidth={ wrapperWidth } data-testid="kb-edit-drawer">
      <ResizerWrapper ref={ resizerRef } children={ <Resizer /> } />
      <DetailWrapper>
        <Header onClose={ handleClose } />
        <TabsSelector scope={ shortcutScope } />
        { showTransparency && <Transparency /> }
        <Tabs tabRef={ ref } onScroll={ onScroll } showTransparency={ showTransparency } />
      </DetailWrapper>
    </Wrapper>
      )
    : null;
};

export default VulnTemplateDetail;
